import { render, staticRenderFns } from "./table-review-element.vue?vue&type=template&id=61da9d18&scoped=true"
import script from "./table-review-element.vue?vue&type=script&lang=js"
export * from "./table-review-element.vue?vue&type=script&lang=js"
import style0 from "./table-review-element.vue?vue&type=style&index=0&id=61da9d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da9d18",
  null
  
)

export default component.exports